module.exports = __webpack_public_path__ + "img/business_intro_3.9ef34b36.jpg";